import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import useSettingsStore from 'store/settingsStore';

interface Breadcrumb {
  label: string;
  url?: string;
}

interface BreadcrumbsProps {
  crumbs: Breadcrumb[];
}

function Breadcrumbs({ crumbs }: BreadcrumbsProps) {
  const { breadcrumbsHidden } = useSettingsStore();

  if (breadcrumbsHidden) {
    return null;
  }

  return (
    <div className="mb-10">
      {crumbs.map((b, index) => {
        return (
          <Fragment key={b.url + '_' + index}>
            {index !== 0 && ' > '}
            {b.url && (
              <Link className="border-b-solid border-b" to={b.url}>
                {b.label}
              </Link>
            )}
            {!b.url && <span className="">{b.label}</span>}
          </Fragment>
        );
      })}
    </div>
  );
}

export default Breadcrumbs;
